'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ColorPicker = require('./ColorPicker');

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ColorPicker2["default"];
module.exports = exports['default'];